export class SessionServiceConstants {
  public static LOGIN_TOKEN_DEFAULT = 'v2/secm/oam/oauth2/token';
  public static LOGIN_TOKEN_NO_VERSION = 'secm/oam/oauth2/token';
  public static USER_APPLICATION_MENU = 'v1/secm/applications/menu';
  public static USER_LEGAL_ENTITIES = 'v5/sm/mylegalentities';
  public static LOGIN_TOKEN_V6 = 'v6/secm/oam/oauth2/token';
}
